/**
 * Inline SVG illustrations for the install guide. Drawn rather than screenshotted so they
 * stay sharp, work in both colour schemes, add no network request, and never go stale
 * when iOS changes its wallpaper.
 */
const frame = {
  fill: 'var(--color-surface)',
  stroke: 'var(--color-border)',
  strokeWidth: 2,
} as const;

function PhoneFrame({ children }: { children: React.ReactNode }) {
  return (
    <>
      <rect x="14" y="4" width="64" height="84" rx="10" {...frame} />
      <rect x="34" y="8" width="24" height="4" rx="2" fill="var(--color-border)" />
      {children}
    </>
  );
}

/** Step 1 — the Share button in the Safari toolbar. */
export function ShareButtonIllustration() {
  return (
    <svg viewBox="0 0 92 92" role="img" aria-labelledby="ill-share-title">
      <title id="ill-share-title">
        Thanh công cụ Safari ở cạnh dưới màn hình, nút Chia sẻ hình mũi tên đi lên nằm ở giữa
      </title>
      <PhoneFrame>
        <rect x="20" y="70" width="52" height="14" rx="7" fill="var(--color-bg)" />
        <path
          d="M46 82v-9m0-9v9m0-9-4 4m4-4 4 4"
          stroke="var(--color-accent)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <rect
          x="40"
          y="70"
          width="12"
          height="14"
          rx="3"
          fill="none"
          stroke="var(--color-accent)"
          strokeWidth="2.5"
        />
      </PhoneFrame>
    </svg>
  );
}

/** Step 2 — scrolling the share sheet down to the "Add to Home Screen" row. */
export function ShareSheetIllustration() {
  return (
    <svg viewBox="0 0 92 92" role="img" aria-labelledby="ill-sheet-title">
      <title id="ill-sheet-title">
        Bảng chia sẻ trượt lên, danh sách các dòng lệnh, dòng được đánh dấu là Thêm vào MH chính
      </title>
      <PhoneFrame>
        <rect x="20" y="30" width="52" height="54" rx="8" fill="var(--color-bg)" />
        <rect x="26" y="38" width="40" height="6" rx="3" fill="var(--color-border)" />
        <rect x="26" y="50" width="40" height="6" rx="3" fill="var(--color-border)" />
        <rect x="26" y="62" width="40" height="8" rx="4" fill="var(--color-accent)" />
        <path
          d="M40 66h12M46 62v8"
          stroke="var(--color-accent-contrast)"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </PhoneFrame>
    </svg>
  );
}

/** Step 3 — confirming with the Add button. */
export function ConfirmIllustration() {
  return (
    <svg viewBox="0 0 92 92" role="img" aria-labelledby="ill-confirm-title">
      <title id="ill-confirm-title">Màn hình xác nhận với nút Thêm ở góc trên bên phải</title>
      <PhoneFrame>
        <rect x="20" y="22" width="52" height="12" rx="6" fill="var(--color-bg)" />
        <rect x="52" y="24" width="18" height="8" rx="4" fill="var(--color-accent)" />
        <rect x="24" y="42" width="20" height="20" rx="5" fill="var(--color-accent)" />
        <rect x="48" y="46" width="20" height="5" rx="2.5" fill="var(--color-border)" />
        <rect x="48" y="55" width="14" height="5" rx="2.5" fill="var(--color-border)" />
      </PhoneFrame>
    </svg>
  );
}

/** Step 4 — the installed app icon on the home screen. */
export function HomeScreenIllustration() {
  return (
    <svg viewBox="0 0 92 92" role="img" aria-labelledby="ill-home-title">
      <title id="ill-home-title">
        Màn hình chính của điện thoại với biểu tượng ứng dụng Personal Finance đã được thêm
      </title>
      <PhoneFrame>
        <rect x="24" y="26" width="18" height="18" rx="5" fill="var(--color-border)" />
        <rect x="50" y="26" width="18" height="18" rx="5" fill="var(--color-border)" />
        <rect x="24" y="52" width="18" height="18" rx="5" fill="var(--color-accent)" />
        <path
          d="M28 66v-7m5 7v-11m5 11v-4"
          stroke="var(--color-accent-contrast)"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <rect x="50" y="52" width="18" height="18" rx="5" fill="var(--color-border)" />
      </PhoneFrame>
    </svg>
  );
}
